import { useEffect, useState } from 'react'

import polarisConfig from './polarisConfig'

export const WIDGET_ID = 'reviews-io-widget'

const SCRIPT_SRC = 'https://widget.reviews.io/polaris/build.js'
// Class Polaris puts on each rendered review (observed on widget build 205, October 2026).
const REVIEW_ITEM_SELECTOR = '.R-ContentList__item'

const loadWidgetScript = (onLoad) => {
  let script = document.querySelector(`script[src="${SCRIPT_SRC}"]`)
  if (script?.dataset.loaded) {
    onLoad()
    return () => {}
  }
  if (!script) {
    script = document.createElement('script')
    script.src = SCRIPT_SRC
    script.async = true
    document.head.appendChild(script)
  }
  const handleLoad = () => {
    script.dataset.loaded = 'true'
    onLoad()
  }
  script.addEventListener('load', handleLoad)
  return () => script.removeEventListener('load', handleLoad)
}

// Loads the Reviews.io widget into the mount node and reports once it has rendered a review
const useReviewsWidget = () => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const target = document.getElementById(WIDGET_ID)
    if (!target) return undefined

    const observer = new MutationObserver(() => {
      if (!target.querySelector(REVIEW_ITEM_SELECTOR)) return
      setReady(true)
      observer.disconnect()
    })
    observer.observe(target, { childList: true, subtree: true })

    const removeLoadListener = loadWidgetScript(() => {
      if (typeof window.ReviewsWidget !== 'function') return
      try {
        new window.ReviewsWidget(`#${WIDGET_ID}`, polarisConfig)
      } catch (error) {
        observer.disconnect()
        console.error('Reviews.io widget failed to start', error)
      }
    })

    return () => {
      observer.disconnect()
      removeLoadListener()
    }
  }, [])

  return ready
}

export default useReviewsWidget
